import { render, staticRenderFns } from "./CompanyLeaveDetails.vue?vue&type=template&id=79b947e3&scoped=true&"
import script from "./CompanyLeaveDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyLeaveDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b947e3",
  null
  
)

export default component.exports